module.exports = {"341372001":"金海街道","341372402":"鞋城行政区域管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341372.json
// module id = 1136
// module chunks = 0